import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ToastrService } from 'ngx-toastr';
import { Message } from 'src/app/core/class/message';
import { ErrorCode } from 'src/app/core/constants/error-code';
import { CustomerService } from 'src/app/core/services/customer.service';
import { WarningComponent } from 'src/app/shared/components/warning/warning.component';

@Component({
  selector: 'app-update-group-customer-dialog',
  templateUrl: './update-group-customer-dialog.component.html',
  styleUrls: ['./update-group-customer-dialog.component.scss']
})
export class UpdateGroupCustomerDialogComponent implements OnInit {
  group = {
    name: '',
    description: '',
    id: '',
    createdTime: ''
  }
  groupNameControl: FormControl;
  groupName: string = ''
  description: string = '';
  isFormChanging: boolean = false;
  constructor(
    public dialogRef: MatDialogRef<UpdateGroupCustomerDialogComponent>,
    private toast: ToastrService,
    private dialog: MatDialog,
    private message: Message,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private customerService: CustomerService,
  ) {
    // them chuc nang close message băng Esc vaf click chuot
    dialogRef.disableClose = false;
    this.group = this.data
  }

  onNoClick() {
    if (this.isFormChanging) {
      const dialogRe = this.dialog.open(WarningComponent, {
        width: '350px',
        data: this.message.getMessage('messages.confirm_change_data')
      });
      dialogRe.afterClosed().subscribe(rs => {
        if (rs) {
          this.dialog.closeAll()
        }
        dialogRe.close();
      });
    } else {
      this.dialogRef.close()
    }
  }

  ngOnInit() {
    this.groupNameControl = new FormControl('', Validators.required);
  }

  onSave(){
    this.customerService.groupCustomerUpdate(this.group).subscribe(res => {
      if(res && res.success){
        this.toast.success(this.message.getMessage('messages.update_group_success'));
        this.dialogRef.close(res.success);
      }else{
        this.toast.error(res.message);
        if(ErrorCode.GroupCustomerRemoved == res.code){
          this.dialogRef.close(res.code)
        }
      }
    })
  }

}
